// Regex part: https://stackoverflow.com/questions/6208367/regex-to-match-stuff-between-parentheses
function extractHsla(hsla) {
    var regex = /\((.*?)\)/g;
    var tempString = regex.exec(hsla);
    if (tempString === null || tempString[1] === '') {
        throw Error('Not a valid HSLA value');
    }
    var tempHsla = tempString[1].split(',');
    var h = Number(tempHsla[0]);
    var s = Number(tempHsla[1].substr(0, tempHsla[1].length - 1)) / 100;
    var l = Number(tempHsla[2].substr(0, tempHsla[2].length - 1)) / 100;
    var a = Number(tempHsla[3]);
    return [h, s, l, a];
}
// Conversion: https://css-tricks.com/converting-color-spaces-in-javascript/
/**
 *
 * Convert hsla colour format to rgba or hex format
 * @param hsla 'hsla(h, s, l, a)' as string
 * @param targetFormat 'rgba' | 'hex'
 */
export function hslaConverter(hsla, targetFormat) {
    var _a = extractHsla(hsla), h = _a[0], s = _a[1], l = _a[2], a = _a[3];
    var c = (1 - Math.abs(2 * l - 1)) * s;
    var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    var m = l - c / 2;
    var r = 0;
    var g = 0;
    var b = 0;
    if ((h >= 0 && h < 60) || h === 360) {
        r = c;
        g = x;
        b = 0;
    }
    else if (h >= 60 && h < 120) {
        r = x;
        g = c;
        b = 0;
    }
    else if (h >= 120 && h < 180) {
        r = 0;
        g = c;
        b = x;
    }
    else if (h >= 180 && h < 240) {
        r = 0;
        g = x;
        b = c;
    }
    else if (h >= 240 && h < 300) {
        r = x;
        g = 0;
        b = c;
    }
    else if (h >= 300 && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    if (targetFormat === 'rgba') {
        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);
        return "rgba(" + r + "," + g + "," + b + "," + a + ")";
    }
    var hex1 = Math.round((r + m) * 255).toString(16);
    var hex2 = Math.round((g + m) * 255).toString(16);
    var hex3 = Math.round((b + m) * 255).toString(16);
    // Prepend 0s, if necessary
    if (hex1.length === 1) {
        hex1 = "0" + hex1;
    }
    if (hex2.length === 1) {
        hex2 = "0" + hex2;
    }
    if (hex3.length === 1) {
        hex3 = "0" + hex3;
    }
    return "#" + hex1 + hex2 + hex3;
}
export function paletteTransformer(palette, targetFormat) {
    var palettePair = Object.entries(palette);
    return palettePair.reduce(function (acc, _a) {
        var name = _a[0], value = _a[1];
        acc[name] = hslaConverter(value, targetFormat);
        return acc;
    }, {});
}
//# sourceMappingURL=hslaConverter.js.map